import { WORKFLOW_ACTIONS, WORKFLOW_TRIGGERS, WorkflowStep } from "@typings/api-models";

const stepName = (step: Pick<WorkflowStep, 'type' | 'eventName'>): string => {
  if (step?.eventName === WORKFLOW_ACTIONS.SEND_MESSAGE) {
    return 'Send Message';
  }
  if (step?.eventName === WORKFLOW_ACTIONS.SEND_EMAIL) {
    return 'Send Email';
  }
  if (step?.eventName === WORKFLOW_ACTIONS.SEND_DOCUMENT_REQUEST) {
    return 'Send Document Request';
  }
  if (step?.eventName === WORKFLOW_TRIGGERS.CART_ABANDONED) {
    return 'Abandoned Cart';
  }
  if (step?.eventName === WORKFLOW_TRIGGERS.DOCUMENTS_UPLOADED) {
    return 'Document Upload Complete';
  }
  if (step?.eventName === WORKFLOW_TRIGGERS.PRODUCT_PURCHASED) {
    return 'On Purchase';
  }
  if (step?.eventName === WORKFLOW_TRIGGERS.UPCOMING_BOOKING) {
    return 'Upcoming Booking';
  }
  if (step?.eventName === WORKFLOW_TRIGGERS.INITIATE_CTA) {
    return 'Initiate';
  }
  if (step?.eventName === WORKFLOW_TRIGGERS.FORM_REQUEST_COMPLETED) {
    return 'Form Request Complete';
  }
  return 'Workflow Step';
};

export default stepName;